import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { images } from '../data/mock';
import { Shield, Clock, Heart, Award } from 'lucide-react';

const WhyChooseUs = () => {
  const { language, t } = useLanguage();

  const features = [
    { icon: Shield, ...t.about.features[0] },
    { icon: Clock, ...t.about.features[1] },
    { icon: Heart, ...t.about.features[2] },
    { icon: Award, ...t.about.features[3] },
  ];

  return (
    <section className="py-20 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image Side */}
          <div className="relative">
            <div className="relative z-10">
              <img
                src={images.livingRoom}
                alt="Clean home"
                loading="lazy"
                width={600}
                height={500}
                className="rounded-2xl shadow-2xl w-full object-cover h-[500px]"
              />
            </div>
            {/* Floating Card */}
            <div className="absolute -bottom-6 -right-6 bg-white rounded-xl shadow-xl p-6 z-20 max-w-xs hidden md:block">
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 bg-orange-100 rounded-full flex items-center justify-center">
                  <Award className="text-orange-600" size={28} />
                </div>
                <div>
                  <p className="text-2xl font-bold text-gray-900">10+</p>
                  <p className="text-sm text-gray-600">
                    {language === 'sv' ? 'års erfarenhet' : 'years experience'}
                  </p>
                </div>
              </div>
            </div>
            {/* Background Decoration */}
            <div className="absolute -top-8 -left-8 w-full h-full bg-purple-100 rounded-2xl -z-10" />
          </div>

          {/* Content Side */}
          <div>
            <div className="inline-flex items-center gap-2 bg-purple-100 text-purple-700 px-4 py-2 rounded-full text-sm font-medium mb-4">
              <Shield size={16} />
              {language === 'sv' ? 'Varför vi?' : 'Why Us?'}
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              {t.about.whyUs}
            </h2>
            <p className="text-gray-600 mb-8 leading-relaxed">
              {t.about.subtitle}
            </p>

            {/* Features */}
            <div className="space-y-6">
              {features.map((feature, index) => (
                <div key={index} className="flex gap-4 group">
                  <div className="w-12 h-12 bg-purple-100 group-hover:bg-purple-600 rounded-xl flex items-center justify-center flex-shrink-0 transition-colors">
                    <feature.icon className="text-purple-600 group-hover:text-white transition-colors" size={22} />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">
                      {feature.title}
                    </h3>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      {feature.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
